import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { SuperSaleGroupProductComponent } from '../super-sale-group-product/super-sale-group-product.component';

@Component({
  selector: 'app-business-wise-sale-and-transaction',
  templateUrl: './business-wise-sale-and-transaction.component.html',
  styleUrls: ['./business-wise-sale-and-transaction.component.scss']
})
export class BusinessWiseSaleAndTransactionComponent implements OnInit {

  title:any;
  from_date:any;
  to_date:any;
  business_code:any;
  sale_dict:any;

  constructor(private http:HttpService, public global: GlobalService, private dialog: MatDialog) {
    this.title = this.global._active_display_name;
   }

  getClicked(){

    let data_dict = {
      'from_date': this.from_date, 
      'to_date': this.to_date, 
      'business_code': this.business_code, 
    }

    this.http.serveDateRangeWiseSaleAndTrasactionData(data_dict).subscribe((data) => {
      console.log(data);
      this.sale_dict = data;
    },(error) => {
      console.log(error);
    })

  }

  ProductReportCalled(business_code, from_date, to_date) {
    const dialogRef = this.dialog.open(SuperSaleGroupProductComponent, {
      height: '394px',
      width: '900px',
      position: { right : '230px'},
      data: {
        'business_code': business_code,
        'from_date': from_date,
        'to_date': to_date,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        console.log(res);
      }
    });
  }



  ngOnInit() {
  }

}
